var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('resource-view',{attrs:{"loading":_vm.loading,"resource":_vm.quotaResource,"tabs":_vm.tabs,"historyTab":_vm.activeTab},on:{"onTabChange":function (tab) { this$1.activeTab = tab }}})}
var staticRenderFns = []

export { render, staticRenderFns }